import "./style.less";
// eslint-disable-next-line no-unused-vars
// import Logo from "../../../../assets/svg/logo-desktop-kbh.svg";

export default function FooterGlobal() {
    return {
        restrict: "E",
        scope: {},
        replace: false,
        template: require("./template.html"),

        controller: function ($scope, siteService) {
            // GET FOOTER INFO
            siteService.getFooter().then(function (pagedata) {
                $scope.oFooter = pagedata;
            });
        },
    };
}
